import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-how-it-works',
  templateUrl: 'how-it-works.component.html',
  styleUrls: ['how-it-works.component.css']
})
export class HowItWorksComponent implements OnInit {

  public sectionTitle:string = "Come Funziona";
  public sectionDescription1:string = "Nello spirito della Share Economy condivido con altri un bene o un servizio che possiedo con persone che lo stanno cercando.";



  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/landingpage/sections/how-it-works/how-it-works.component.ts